import { useState } from 'react';
import styles from './RegisterForm.module.css';

export default function RegisterForm({ onRegister }) {
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    companyName: '',  // NEW FIELD
    isOwner: true      // Set true by default for now
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onRegister(form);
  };

  return (
    <div>
      <div className={styles.logoContainer}>
        <img src="/logo.png" alt="Nodel logo" className={styles.logo} />
        <p className={styles.slogan}>Organize. Schedule. Deliver.</p>
        <p className={styles.subtitle}>Create your account</p>
      </div>

      <form className={styles.form} onSubmit={handleSubmit}>
      <input
        className={styles.input}
        name="name"
        placeholder="Full Name"
        onChange={handleChange}
        required
      />
      <input
        className={styles.input}
        name="email"
        type="email"
        placeholder="Email"
        onChange={handleChange}
        required
      />
      <input
        className={styles.input}
        name="password"
        type="password"
        placeholder="Password"
        onChange={handleChange}
        required
      />
      <input
        className={styles.input}
        name="companyName"
        placeholder="Company Name"
        onChange={handleChange}
        required
      />
      <button className={styles.button} type="submit">Register</button>
    </form>
    </div>
  );
}
